import { render, staticRenderFns } from "./PermissionNotice.vue?vue&type=template&id=4c00fe7c"
import script from "./PermissionNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionNotice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PermissionNotice.vue?vue&type=style&index=0&id=4c00fe7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports